/* eslint-disable import/no-mutable-exports */
var twitter = {
  init: function (matchHeight) {
  	$('.twittersection-block .twitter-item').matchHeight();
  }
};

export default twitter;